import { ref } from "vue";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import store from "../store";
import { app } from "../firebase/config";
import { resolveAccountContext, applyAccountContextToStore } from "./accountContext";

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);

const getUserDocument = async (resolvedOwnerUid = null) => {
  const userDocuments = ref(null);

  let userId = resolvedOwnerUid || store.state.accountOwnerId || auth.currentUser?.uid;
  if (!userId) {
    console.error("No user is currently signed in.");
    return { userDocuments, checkAccountLock: () => false };
  }

  if (auth.currentUser && !resolvedOwnerUid && !store.state.accountOwnerId) {
    const context = await resolveAccountContext(auth.currentUser);
    if (context) {
      applyAccountContextToStore({
        authUser: auth.currentUser,
        context,
        store,
      });
      userId = context.ownerUid;
    }
  }

  const collectionRef = doc(db, "users", userId);

  try {
    const docSnap = await getDoc(collectionRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      userDocuments.value = data;
      store.state.userConfig = data;
      store.state.isSubscribed = data.subscription;
      store.state.isTrial = data.trial;
      store.state.accountLock = data.accountLock;
      store.state.customer = data.customer;
    } else {
      console.error("No such document!");
    }
  } catch (error) {
    console.log("Error getting document:", error);
  }

  const checkAccountLock = async () => {
    return store.state.accountLock ? true : false;
  };

  return { userDocuments, checkAccountLock };
};

export default getUserDocument;
